import { useEffect } from 'react';
export const META_PIXEL_ID = '1481216457390096';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

/**
 * Meta Pixel — ładowany dokładnie raz na stronę.
 * Zabezpieczenia: znacznik na <html>, sprawdzenie window.fbq oraz istniejącego <script>.
 */
export function MetaPixel() {
  useEffect(() => {
    const root = document.documentElement;
    if (root.dataset.metaPixel === META_PIXEL_ID) return;
    if (document.getElementById('meta-pixel-script')) return;
    root.dataset.metaPixel = META_PIXEL_ID;

    /* eslint-disable */
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.id = 'meta-pixel-script';
      t.async = true;
      t.src = v;
      // Wstaw przed pierwszym <script>; jeśli strona go nie ma, dodaj do <head>.
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');

    // <noscript> fallback — dodawany raz, tylko jeśli jeszcze nie istnieje.
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'meta-pixel-noscript';
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" alt="" />`;
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}